export const PROVIDERS = [
  { value: 'PROPSTACK', text: 'Propstack' },
  { value: 'ONOFFICE', text: 'onOffice' },
  { value: 'FLOWFACT', text: 'Flowfact' },
]
